import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import MainPage from '../components/MainPage';
import getTagsForLevel from '../components/Master/functions/getTagsForLevel';

const MasterContainer = () => {
  const dispatch = useDispatch();
  const { apiToken, isLogin, showUnavailableTags } = useSelector(state => ({
    apiToken: state.main.apiToken,
    isLogin: state.main.isLogin,
    showUnavailableTags: state.master.showUnavailableTags,
    targetGroupId: state.main.targetGroupId,
  }));

  useEffect(() => {
    dispatch({ type: 'OPEN_MASTER' });
    dispatch(getTagsForLevel(apiToken, null, 0, showUnavailableTags));
  }, [dispatch, apiToken, showUnavailableTags]);

  if (!isLogin) {
    return <Redirect to="/login" />;
  }

  return <MainPage />;
};

export default MasterContainer;
